export const state = {
  loading: true,
  user: {},
  auth0Client: null,
  authenticated: false,
  popupOpen: false,
  error: null,
  notifications: []
}

export const mutations = {
  setLoading (state, { loading }) {
    state.loading = loading
  },
  setUser (state, { user }) {
    state.user = user
  },
  setAuthenticated (state, { authenticated }) {
    state.authenticated = authenticated
  },
  setAuth0Client (state, { client }) {
    state.auth0Client = client
  },
  setPopupOpen (state, { popup }) {
    state.popupOpen = popup
  },
  setError (state, { e }) {
    state.error = e
  },
  setNotifications (state, { notifications }) {
    if (!notifications) {
      state.notifications = []
    } else {
      state.notifications = notifications
    }
  }
}

export const actions = {
  initialize ({ commit }, { loading, authenticated, user }) {
    commit('setLoading', { loading })
    commit('setAuthenticated', { authenticated })
    commit('setUser', { user })
  },
  async handleRedirectCallback ({ state, commit }) {
    commit('setLoading', { loading: true })
    try {
      await state.auth0Client.handleRedirectCallback()
      const user = await state.auth0Client.getUser()
      commit('setUser', { user })
      commit('setAuthenticated', { authenticated: true })
    } catch (e) {
      commit('setError', { e })
    } finally {
      commit('setLoading', { loading: false })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
